import { Formik } from 'formik';
import T from 'prop-types';
import React from 'react';
import { object, string } from 'yup';
import getOr from 'lodash/fp/getOr';
import Control from '../Control';
import text from '../../../text';
import Button from '../../button/Button';
var schema = object().shape({
    pointerraId: string().matches(/^[a-zA-Z0-9]{22}$/, {
        message: text('invalidParam', {
            param: 'Pointerra ID'
        }),
        excludeEmptyString: true
    })
});
var PointerraIDForm = function(props) {
    var onSubmit = props.onSubmit, onCancel = props.onCancel, job = props.job, submitState = props.submitState;
    return /*#__PURE__*/ React.createElement("div", {
        className: "PointerraIDForm"
    }, /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            pointerraId: getOr('', [
                'point_clouds',
                0,
                'pointerra_id'
            ], job)
        },
        validationSchema: schema
    }, function(param) {
        var handleChange = param.handleChange, isValid = param.isValid, values = param.values, errors = param.errors, dirty = param.dirty;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Control, {
            label: text('enterIDNumber'),
            as: "input",
            type: "text",
            name: "pointerraId",
            isFailed: !!errors.pointerraId || submitState.error,
            value: (values === null || values === void 0 ? void 0 : values.pointerraId) || '',
            onChange: function(e) {
                return handleChange(e);
            },
            placeholder: text('enterIDNumber'),
            validationError: errors.pointerraId || submitState.error,
            autoComplete: "off"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "form-footer"
        }, /*#__PURE__*/ React.createElement(Button, {
            loading: submitState.loading,
            onClick: function() {
                return onSubmit(job === null || job === void 0 ? void 0 : job.project.id, values === null || values === void 0 ? void 0 : values.pointerraId);
            },
            disabled: !isValid || !dirty
        }, text('update')), /*#__PURE__*/ React.createElement("a", {
            name: "cancel",
            href: "#",
            onClick: onCancel
        }, text('cancel'))));
    }));
};
PointerraIDForm.propTypes = {
    onSubmit: T.func.isRequired
};
export default PointerraIDForm;
